export const EVENTS = {
  MENU: {
    SHOW: 'menu.show'
  }
};
